import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import { SpacesSiteUrls } from '../../SpacesSiteUrls';
import * as React from 'react';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { SharedViewsButton } from '../../SharedWithMe/SharedViewsButton';
import { SharedViewsButtonStyle } from '../../SharedWithMe/style/SharedViewsButtonStyle';

export interface ISharedViewsCellProps {
  showButton: boolean;
  contentId: string;
}

export function SharedViewsCell(
    getSharedViewsData: (rowData: DataGrid.Row) => ISharedViewsCellProps,
    urls: SpacesSiteUrls
): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      React.createFactory(class extends React.Component<BodyCell.Props, any> {
        public render(): JSX.Element {
          const props = getSharedViewsData(this.props.row);
          return (props.showButton &&
              <SharedViewsButton
                  className={SharedViewsButtonStyle.List}
                  containerClassName={SharedViewsButtonStyle.ListContainer}
                  urls={urls}
                  viewId={props.contentId}
              />
          );
        }
      }),
      {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        height: 'inherit',
        justifyContent: 'center',
        lineHeight: 'inherit',
        textOverflow: 'unset',
        verticalAlign: 'middle',
      }
  );
}
